import { WhitelabelConstants } from "../constants";

const initialstate = {
  loading: false,
  WhitelabelRequest: false,
  WhitelabelSuccess: false,
  WhitelabelFailure: false,
  items: [],
};

export function whitelabel(state = initialstate, action) {
  switch (action.type) {
    case WhitelabelConstants.GETWHITELABEL_REQUEST:
      return {
        ...state,
        loading: true,
        WhitelabelRequest: true,
        WhitelabelFailure: false,
        WhitelabelSuccess: false,
        whitelabel: action.response,
      };
    case WhitelabelConstants.GETWHITELABEL_SUCCESS:
      return {
        ...state,
        items: action.payload,
        loading: false,
        WhitelabelRequest: false,
        WhitelabelFailure: false,
        WhitelabelSuccess: true,
        whitelabel: action.whitelabel,
      };
    case WhitelabelConstants.GETWHITELABEL_FAILURE:
      return {
        ...state,
        loading: false,
        WhitelabelRequest: false,
        WhitelabelSuccess: false,
        WhitelabelFailure: true,
        whitelabel: action.response,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/whitelabel.reducer.js